import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  centered?: boolean;
  light?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  centered = false,
  light = false
}: SectionHeadingProps) {
  return <div className={centered ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-14">
      <p className={`mb-4 text-xs font-extrabold uppercase tracking-[0.22em] ${light ? 'text-[#f0c7bc]' : 'text-[#a95848]'}`} data-id="element-15">
        {eyebrow}
      </p>
      <h2 className={`font-editorial text-4xl leading-[1.02] sm:text-5xl ${light ? 'text-[#fffaf2]' : 'text-[#282820]'}`} data-id="element-16">
        {title}
      </h2>
      {description ? <p className={`mt-5 text-base leading-7 sm:text-lg ${light ? 'text-[#e8dfd1]' : 'text-[#5f6055]'}`} data-id="element-17">
          {description}
        </p> : null}
    </div>;
}